/*
 * This file is part of Universal Media Server, based on PS3 Media Server.
 *
 * This program is a free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; version 2 of the License only.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU General Public License for more
 * details.
 *
 * You should have received a copy of the GNU General Public License along with
 * this program; if not, write to the Free Software Foundation, Inc., 51
 * Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 */
import { Button } from '@mantine/core'

import { ValueLabelData } from '../../services/i18n-service'

export default function DirectoryBreadcrumbsButton({
  path,
  separator,
  setCurrentPath,
}: {
  path: ValueLabelData
  separator?: string
  setCurrentPath: (path: string) => void
}) {
  return (
    <Button
      onClick={() => setCurrentPath(path.value)}
      variant="default"
      size="compact-md"
    >
      {path.label + separator}
    </Button>
  )
}
